module.exports = __webpack_public_path__ + "img/20240625160417.c04fd510.jpg";